import QueryKey from '@/enums/QueryKey';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useProcedureResponsiblesData() {
    const { data: procedureResponsibles, isPending: isProcedureResponsiblesPending } = useQuery({
        queryKey: [QueryKey.DASHBOARD_PROCEDURE_EMPLOYEES],
        queryFn: async () => {
            const { data } = await axios.post(route('v2.dashboard.procedure.employees.get'), {
                keepers: false,
            });
            return data;
        },
        placeholderData: [],
    });

    return {
        procedureResponsibles,
        isProcedureResponsiblesPending,
    };
}
